import { actions as receivedActions } from '@app/store/action/transfers-received';
import { actions as transferActions } from '@app/store/action/transfer';
import { normalizeTransfer } from '@app/transfer-bundle/helpers/normalize-transfer';

export const initialState = {
  isLoaded: false,
  list: [],
};

export default function (state = initialState, action) {
  const { type } = action;

  if (type === receivedActions.RECEIVED_TRANSFERS_SUCCESS) {
    return {
      ...state,
      list: action.list.map(normalizeTransfer),
      isLoaded: true,
    };
  }

  if (type === receivedActions.GET_RECEIVED_TRANSFER_SUCCESS) {
    return {
      ...state,
      transfer: normalizeTransfer(action.transfer),
    };
  }

  if (type === receivedActions.RECEIVED_TRANSFERS_RESET_TRANSFER) {
    return {
      ...state,
      transfer: null,
    };
  }

  if (
    state.isLoaded &&
    type === transferActions.TRANSFER_STATE_DOWNLOADING &&
    action.transferId
  ) {
    return {
      ...state,
      list: state.list.map((receivedTransfer) => {
        if (
          receivedTransfer.transfer &&
          receivedTransfer.recipient &&
          receivedTransfer.recipient.downloaded === false &&
          receivedTransfer.transfer.id === action.transferId
        ) {
          return {
            ...receivedTransfer,
            recipient: {
              ...receivedTransfer.recipient,
              downloaded: true,
            },
          };
        }
        return receivedTransfer;
      }),
    };
  }

  return state;
}
